import { createRouter, createWebHistory } from "vue-router";
import GalleriaFoto from "@/views/PhotoGalley/PhotoGallery.vue";
import GalleriaVideo from "@/views/VideoGallery/VideoGallery.vue";
import PaginaNews from "@/views/NewsPage/NewsPage.vue";
import KnifePage from "@/views/KnifePage/KnifePage.vue";
import LoginPage from "@/views/LoginPage/LoginPage.vue";

let BASE_URL = '/';  

const router = createRouter({
  history: createWebHistory(BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/galleria-foto",
    },
    {
      path: "/galleria-foto",
      component: GalleriaFoto,
      meta: { requiresAuth: true },
    },
    {
      path: "/galleria-video",
      component: GalleriaVideo,
      meta: { requiresAuth: true },
    },
    {
      path: "/pagina-news",
      component: PaginaNews,
      meta: { requiresAuth: true },
    },
    {
      path: "/pagina-coltelli",
      component: KnifePage,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      component: LoginPage,
    },
  ],
});

// Middleware di autenticazione
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;
